import {createSelector} from 'reselect';
import {getListingSummary} from './listingSummary';
import {getSuperlativeBadges} from './listing';
import {getFirstPayment, getPriceLabels, getTotals, getPriceDetails} from './priceDetails';
import {getIsMobile, getDeviceSize, getSiteName} from './system';
import {
    isDatePickerModalOpen,
    isGuestSelectorModalOpen,
    isRequestToBookModalOpen,
    isInquiryModalOpen
} from './modalStates';
import {getBookingType, getTakesInquiries} from './listing';
import {getAbacusTests, getTravelerFeatures, getTripData} from './store';
import {VRBO_WEB_SIMPLE_RIGHT_RAIL_DISPLAY} from '../abacus/experiments';
import {evaluationIsVariant} from '@homeaway/react-experiment';

const getViewDetailsTotalData = createSelector(
    [getPriceLabels, getTotals],
    (labels, totals) => ({
        labels,
        showViewDetailsLink: !!(totals || /* istanbul ignore next */ {}).totalWithoutDeposits,
        totals
    })
);

const getPriceQuotePresentedData = createSelector(
    [getTotals, getPriceDetails, getListingSummary, isRequestToBookModalOpen, getTripData],
    (totals = {}, priceDetails, listingSummary, requestToBookModalOpen, tripData) => ({
        hasTotals: !!totals.totalWithoutDeposits,
        edapPriceQuotePresented: priceDetails.edapPriceQuotePresented,
        loadingRate: listingSummary.loadingRate,
        requestToBookModalOpen,
        adultsCount: tripData.adults,
        arriveDateText: tripData.arriveDateText,
        departDateText: tripData.departDateText
    })
);

const getRightRailData = createSelector(
    [
        getBookingType,
        getListingSummary,
        getViewDetailsTotalData,
        getSiteName,
        isDatePickerModalOpen,
        isGuestSelectorModalOpen,
        isRequestToBookModalOpen,
        isInquiryModalOpen,
        getTakesInquiries,
        getTravelerFeatures,
        getFirstPayment,
        getSuperlativeBadges,
        getIsMobile,
        getAbacusTests,
        getDeviceSize
    ],
    (
        bookingType,
        listingSummary,
        viewDetailsTotalData,
        siteName,
        datePickerPopoverOpen,
        guestSelectorPopoverOpen,
        requestToBookModalOpen,
        inquiryModalOpen,
        takesInquiries,
        travelerFeatures,
        firstPaymentData,
        superlativeBadges,
        isMobile,
        abacusTests,
        deviceSize
    ) => {
        const consolidate =
            deviceSize !== 'sm' &&
            !isMobile &&
            evaluationIsVariant(abacusTests[VRBO_WEB_SIMPLE_RIGHT_RAIL_DISPLAY], 1);

        return {
            listingSummaryData: listingSummary,
            viewDetailsTotalData,
            siteName,
            datePickerPopoverOpen,
            guestSelectorPopoverOpen,
            requestToBookModalOpen,
            inquiryModalOpen,
            showSecondaryAction: bookingType.onlineBookable && takesInquiries,
            firstPaymentData,
            superlativeBadges,
            consolidate
        };
    }
);

export default getRightRailData;
export {getRightRailData, getViewDetailsTotalData, getPriceQuotePresentedData};
